import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('ticketShoppingCart', [
        'itemsInCart',
        'orderCompleted',
        'expiredCart',
    ]),
  },
  methods: {
    ...mapActions('ticketShoppingCart', ['clearCart', 'setExpiredCart']),
    goToHome() {
      this.clearCart(false);
      this.$router.replace('/');
      window.location.reload();
    },
    notifyExpiredCart() {
      this.setExpiredCart(true);
    },
    resetCartAndGoToHome() {
      if (this.itemsInCart > 0) {
        if (!this.orderCompleted) {
          this.notifyExpiredCart();
        }
      } else {
        this.goToHome();
      }
    },
  },
};
